/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { HalJson } from '../models/hal-json';
import { SkumapItemsAssociationsResult } from '../models/skumap-items-associations-result';
import { SkumapTemplateAssociationsResultMap } from '../models/skumap-template-associations-result-map';
import { SkumapTemplateCreateResult } from '../models/skumap-template-create-result';
import { skumapTemplatesGet } from '../fn/sku-map-templates/skumap-templates-get';
import { SkumapTemplatesGet$Params } from '../fn/sku-map-templates/skumap-templates-get';
import { skumapTemplatesItemsItemIdGet } from '../fn/sku-map-templates/skumap-templates-items-item-id-get';
import { SkumapTemplatesItemsItemIdGet$Params } from '../fn/sku-map-templates/skumap-templates-items-item-id-get';
import { skumapTemplatesPost } from '../fn/sku-map-templates/skumap-templates-post';
import { SkumapTemplatesPost$Params } from '../fn/sku-map-templates/skumap-templates-post';
import { skumapTemplatesTemplateIdAssociateGet } from '../fn/sku-map-templates/skumap-templates-template-id-associate-get';
import { SkumapTemplatesTemplateIdAssociateGet$Params } from '../fn/sku-map-templates/skumap-templates-template-id-associate-get';
import { skumapTemplatesTemplateIdAssociatePut } from '../fn/sku-map-templates/skumap-templates-template-id-associate-put';
import { SkumapTemplatesTemplateIdAssociatePut$Params } from '../fn/sku-map-templates/skumap-templates-template-id-associate-put';
import { skumapTemplatesTemplateIdDelete } from '../fn/sku-map-templates/skumap-templates-template-id-delete';
import { SkumapTemplatesTemplateIdDelete$Params } from '../fn/sku-map-templates/skumap-templates-template-id-delete';
import { skumapTemplatesTemplateIdGet } from '../fn/sku-map-templates/skumap-templates-template-id-get';
import { SkumapTemplatesTemplateIdGet$Params } from '../fn/sku-map-templates/skumap-templates-template-id-get';
import { skumapTemplatesTemplateIdItemsItemIdAssociateDelete } from '../fn/sku-map-templates/skumap-templates-template-id-items-item-id-associate-delete';
import { SkumapTemplatesTemplateIdItemsItemIdAssociateDelete$Params } from '../fn/sku-map-templates/skumap-templates-template-id-items-item-id-associate-delete';
import { skumapTemplatesTemplateIdItemsItemIdAssociatePut } from '../fn/sku-map-templates/skumap-templates-template-id-items-item-id-associate-put';
import { SkumapTemplatesTemplateIdItemsItemIdAssociatePut$Params } from '../fn/sku-map-templates/skumap-templates-template-id-items-item-id-associate-put';
import { skumapTemplatesTemplateIdPut } from '../fn/sku-map-templates/skumap-templates-template-id-put';
import { SkumapTemplatesTemplateIdPut$Params } from '../fn/sku-map-templates/skumap-templates-template-id-put';

@Injectable({ providedIn: 'root' })
export class SkuMapTemplatesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `skumapTemplatesGet()` */
  static readonly SkumapTemplatesGetPath = '/skumap/templates';

  /**
   * Get SKU map templates for a tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `skumapTemplatesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  skumapTemplatesGet$Response(params: SkumapTemplatesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & SkumapTemplateAssociationsResultMap>> {
    return skumapTemplatesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get SKU map templates for a tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `skumapTemplatesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  skumapTemplatesGet(params: SkumapTemplatesGet$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
} & SkumapTemplateAssociationsResultMap> {
    return this.skumapTemplatesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
} & SkumapTemplateAssociationsResultMap>): {
'_links'?: HalJson;
} & SkumapTemplateAssociationsResultMap => r.body)
    );
  }

  /** Path part for operation `skumapTemplatesPost()` */
  static readonly SkumapTemplatesPostPath = '/skumap/templates';

  /**
   * Create a new SKU map template (generates ID).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `skumapTemplatesPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  skumapTemplatesPost$Response(params: SkumapTemplatesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & SkumapTemplateCreateResult>> {
    return skumapTemplatesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new SKU map template (generates ID).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `skumapTemplatesPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  skumapTemplatesPost(params: SkumapTemplatesPost$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
} & SkumapTemplateCreateResult> {
    return this.skumapTemplatesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
} & SkumapTemplateCreateResult>): {
'_links'?: HalJson;
} & SkumapTemplateCreateResult => r.body)
    );
  }

  /** Path part for operation `skumapTemplatesTemplateIdGet()` */
  static readonly SkumapTemplatesTemplateIdGetPath = '/skumap/templates/{templateId}';

  /**
   * Get a SKU map template by its ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `skumapTemplatesTemplateIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  skumapTemplatesTemplateIdGet$Response(params: SkumapTemplatesTemplateIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & SkumapTemplateAssociationsResultMap>> {
    return skumapTemplatesTemplateIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a SKU map template by its ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `skumapTemplatesTemplateIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  skumapTemplatesTemplateIdGet(params: SkumapTemplatesTemplateIdGet$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
} & SkumapTemplateAssociationsResultMap> {
    return this.skumapTemplatesTemplateIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
} & SkumapTemplateAssociationsResultMap>): {
'_links'?: HalJson;
} & SkumapTemplateAssociationsResultMap => r.body)
    );
  }

  /** Path part for operation `skumapTemplatesTemplateIdPut()` */
  static readonly SkumapTemplatesTemplateIdPutPath = '/skumap/templates/{templateId}';

  /**
   * Update a SKU map template by its ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `skumapTemplatesTemplateIdPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  skumapTemplatesTemplateIdPut$Response(params: SkumapTemplatesTemplateIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return skumapTemplatesTemplateIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a SKU map template by its ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `skumapTemplatesTemplateIdPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  skumapTemplatesTemplateIdPut(params: SkumapTemplatesTemplateIdPut$Params, context?: HttpContext): Observable<void> {
    return this.skumapTemplatesTemplateIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `skumapTemplatesTemplateIdDelete()` */
  static readonly SkumapTemplatesTemplateIdDeletePath = '/skumap/templates/{templateId}';

  /**
   * Remove a SKU map (and its associations).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `skumapTemplatesTemplateIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  skumapTemplatesTemplateIdDelete$Response(params: SkumapTemplatesTemplateIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return skumapTemplatesTemplateIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove a SKU map (and its associations).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `skumapTemplatesTemplateIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  skumapTemplatesTemplateIdDelete(params: SkumapTemplatesTemplateIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.skumapTemplatesTemplateIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `skumapTemplatesItemsItemIdGet()` */
  static readonly SkumapTemplatesItemsItemIdGetPath = '/skumap/templates/items/{itemId}';

  /**
   * Get a SKU map template by its item ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `skumapTemplatesItemsItemIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  skumapTemplatesItemsItemIdGet$Response(params: SkumapTemplatesItemsItemIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & SkumapTemplateAssociationsResultMap>> {
    return skumapTemplatesItemsItemIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a SKU map template by its item ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `skumapTemplatesItemsItemIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  skumapTemplatesItemsItemIdGet(params: SkumapTemplatesItemsItemIdGet$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
} & SkumapTemplateAssociationsResultMap> {
    return this.skumapTemplatesItemsItemIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
} & SkumapTemplateAssociationsResultMap>): {
'_links'?: HalJson;
} & SkumapTemplateAssociationsResultMap => r.body)
    );
  }

  /** Path part for operation `skumapTemplatesTemplateIdItemsItemIdAssociatePut()` */
  static readonly SkumapTemplatesTemplateIdItemsItemIdAssociatePutPath = '/skumap/templates/{templateId}/items/{itemId}/associate';

  /**
   * Associates an item to a SKU map template.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `skumapTemplatesTemplateIdItemsItemIdAssociatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  skumapTemplatesTemplateIdItemsItemIdAssociatePut$Response(params: SkumapTemplatesTemplateIdItemsItemIdAssociatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return skumapTemplatesTemplateIdItemsItemIdAssociatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Associates an item to a SKU map template.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `skumapTemplatesTemplateIdItemsItemIdAssociatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  skumapTemplatesTemplateIdItemsItemIdAssociatePut(params: SkumapTemplatesTemplateIdItemsItemIdAssociatePut$Params, context?: HttpContext): Observable<void> {
    return this.skumapTemplatesTemplateIdItemsItemIdAssociatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `skumapTemplatesTemplateIdItemsItemIdAssociateDelete()` */
  static readonly SkumapTemplatesTemplateIdItemsItemIdAssociateDeletePath = '/skumap/templates/{templateId}/items/{itemId}/associate';

  /**
   * Removes an association between SKU map and item.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `skumapTemplatesTemplateIdItemsItemIdAssociateDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  skumapTemplatesTemplateIdItemsItemIdAssociateDelete$Response(params: SkumapTemplatesTemplateIdItemsItemIdAssociateDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return skumapTemplatesTemplateIdItemsItemIdAssociateDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Removes an association between SKU map and item.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `skumapTemplatesTemplateIdItemsItemIdAssociateDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  skumapTemplatesTemplateIdItemsItemIdAssociateDelete(params: SkumapTemplatesTemplateIdItemsItemIdAssociateDelete$Params, context?: HttpContext): Observable<void> {
    return this.skumapTemplatesTemplateIdItemsItemIdAssociateDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `skumapTemplatesTemplateIdAssociateGet()` */
  static readonly SkumapTemplatesTemplateIdAssociateGetPath = '/skumap/templates/{templateId}/associate';

  /**
   * Get items associated to a SKU map template.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `skumapTemplatesTemplateIdAssociateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  skumapTemplatesTemplateIdAssociateGet$Response(params: SkumapTemplatesTemplateIdAssociateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & SkumapItemsAssociationsResult>> {
    return skumapTemplatesTemplateIdAssociateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get items associated to a SKU map template.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `skumapTemplatesTemplateIdAssociateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  skumapTemplatesTemplateIdAssociateGet(params: SkumapTemplatesTemplateIdAssociateGet$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
} & SkumapItemsAssociationsResult> {
    return this.skumapTemplatesTemplateIdAssociateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
} & SkumapItemsAssociationsResult>): {
'_links'?: HalJson;
} & SkumapItemsAssociationsResult => r.body)
    );
  }

  /** Path part for operation `skumapTemplatesTemplateIdAssociatePut()` */
  static readonly SkumapTemplatesTemplateIdAssociatePutPath = '/skumap/templates/{templateId}/associate';

  /**
   * Associates an item(s) to a SKU map template.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `skumapTemplatesTemplateIdAssociatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  skumapTemplatesTemplateIdAssociatePut$Response(params: SkumapTemplatesTemplateIdAssociatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return skumapTemplatesTemplateIdAssociatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Associates an item(s) to a SKU map template.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `skumapTemplatesTemplateIdAssociatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  skumapTemplatesTemplateIdAssociatePut(params: SkumapTemplatesTemplateIdAssociatePut$Params, context?: HttpContext): Observable<void> {
    return this.skumapTemplatesTemplateIdAssociatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
